import { useActiveModal, useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useModuleDetailModal = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { closeModal } = useModals();
    const { modalId } = useActiveModal();

    async function viewDetailedConstraintsList(module_id: string) {
        await navigate(`/constraints/constraints?module_id=${module_id}`);
        closeModal(modalId);
    }

    return {
        currentAccount,
        dispatch,
        navigate,
        location,
        viewDetailedConstraintsList
    };
};
